import { render, staticRenderFns } from "./_themeContentPosition.vue?vue&type=template&id=304f4f5f&lang=pug"
import script from "./_themeContentPosition.vue?vue&type=script&lang=js"
export * from "./_themeContentPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports